import React, { FC, Suspense } from 'react';

// must be before any styles
import './styles/index.css';
import 'inter-ui/inter.css';
import 'inter-ui/inter-variable.css';
import { APPLICATION, IS_VET_APPLICATION } from 'shared/config';
import { safeReactLazy } from 'shared/lib/safe.import';

import './config/mobx.bootstrap';
import './config/dialogs.bootstrap';

const getAppComponentLoader = () => {
  if (IS_VET_APPLICATION) {
    document.title = 'VetWay';
    const favicon = document.getElementById('app_icon') as HTMLLinkElement | null;
    if (favicon) {
      favicon.href = '/vw_favicon.png';
    }
  }

  switch (APPLICATION) {
    case 'platform':
    case 'platform-vet':
      return () => import('./platform');

    default:
      return () => import('./scriptsure');
  }
};

const AppComponent = safeReactLazy(getAppComponentLoader());

const App: FC = () => {
  return (
    <Suspense fallback={null}>
      <AppComponent />
    </Suspense>
  );
};
App.displayName = 'App';

export default App;
